$(document).ready( function() {

  $( '.type-text' ).each( function() {

    var items = $( this ).attr( 'title' ) + ';' + $( this ).text();
    $( this ).empty().attr( 'title', '' ).teletype( {
      text: $.map( items.split( ';' ), $.trim ),
      typeDelay: 10,
      backDelay: 20,
      cursor: '|',
      delay: 3000,
      preserve: false,
      prefix: '',
      loop: 0
    } );

  } );

} )



//////////////////
// WEBPACK FOOTER
// ./js/modules/type-text.js
// module id = 31
// module chunks = 0